import { SeuFromApiConverter, SeuRevision, SeuRevisionApi } from '@seu-types';

export const revisionsConverter: SeuFromApiConverter<
  SeuRevisionApi,
  SeuRevision
> = {
  fromApi: (input) => ({
    ...input,
    createdAt: new Date(input.createdAt),
  }),
};
